import { Component, Output, EventEmitter, Input } from '@angular/core';
import { BaseComponent } from '@varsity/components';
import {
    LoggingService, TokenService, LocalStorageService,
    NotificationsService, AccountService, PlatformService,
    TicketsService, Ticket, TransferMethod,
    TransferRecipient
} from "@varsity/services";
import { ViewController, ToastController, NavParams, PopoverController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the TransferTicketsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'transfer-tickets',
    templateUrl: 'transfer-tickets.html'
})
export class TransferTicketsComponent extends BaseComponent {

    text: string;
    @Input() protected transferResult: boolean | null = null;
    @Output() public onTransferClicked: EventEmitter<Ticket[]> = new EventEmitter();
    tickets: Ticket[];
    ticketsWithGateClosed: boolean = false;
    selectedTransferMethod: TransferMethod;
    availableTransferMethods: TransferMethod[] = [];
    textRecipients: TransferRecipient[] = [];
    emailRecipients: TransferRecipient[] = [];
    availableRecipients: TransferRecipient[] = [];
    selectedRecipient: TransferRecipient;
    cid: number;
    receiptFlag: boolean;
    filteredRecipients: TransferRecipient[];
    recipientIsSet: boolean = false;
    searchTerm: any;
    dbName: string = "";
    devicePlatfor: string = "";

    constructor(
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected accountService: AccountService,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected ticketsService: TicketsService,
        protected platformService: PlatformService,
        protected popoverCtrl: PopoverController,
        protected navParams: NavParams,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "TransferTicketsComponent"
        );
        console.log('Hello TransferTicketsComponent Component');
        this.text = 'Hello World';
    }

    ngOnInit() {
        super.ngOnInit();

        this.ticketsService.getRecentRecipients().subscribe((value) => {
            if (value && value.length > 0) {
                this.availableRecipients = value;
                this.textRecipients = value.filter(r => r.MobileNumber);
                this.emailRecipients = value.filter(r => r.Email && r.Email.length > 0);
            }
        });

        this.selectedRecipient = new TransferRecipient();
        this.tickets = this.navParams.get('tickets');
        if (this.navParams.get('data')) {
            this.cid = this.navParams.get('data').confirmationID || null;
            this.receiptFlag = this.navParams.get('data').SendReceiptFlag;
            this.dbName = this.navParams.get('data').dbName || "";
        }
        // nice example for debounce
        // https://stackoverflow.com/questions/32051273/angular-and-debounce

        if (this.tickets.filter(p => p.GatesClosedFlag).length > 0) {
            this.ticketsWithGateClosed = true;
        }

        let activeGateTickets: Ticket[] = this.tickets.filter(el => el.TicketAccountActions.ShowGateValidate === true);

        if (activeGateTickets.length >= 1) {
            this.availableTransferMethods.push(
                {
                    Name: "Text",
                    Value: "text",
                    IsSelected: true
                }
            );
        } else {
            this.availableTransferMethods.push(
                {
                    Name: "Email",
                    Value: "email",
                    IsSelected: true
                },
                {
                    Name: "Text",
                    Value: "text",
                    IsSelected: false
                }
            );
        }


        this.selectedTransferMethod = this.availableTransferMethods.filter(tm => tm.IsSelected)[0];
        this.loggingService.log("INI selected treansfer", this.selectedTransferMethod);
    }

    setUniqueCheck(checkedTransferMethod: TransferMethod) {
        checkedTransferMethod.IsSelected = !checkedTransferMethod.IsSelected;
        this.selectedTransferMethod = checkedTransferMethod;
        this.availableTransferMethods.forEach(m => {
            if (m.Value != checkedTransferMethod.Value) {
                m.IsSelected = false;
            }
        })
        this.searchTerm = null;
        this.selectedRecipient = new TransferRecipient();
        this.loggingService.debug("Selected transfer method", this.selectedTransferMethod);
        this.loggingService.debug("Available methods", this.availableTransferMethods);
    }

    Cancel() {
        this.viewCtrl.dismiss({
            result: this.transferResult
        });
    }

    sendTickets(searchTerm: any) {
        if (this.selectedTransferMethod && this.selectedTransferMethod.IsSelected) {
            if (this.selectedTransferMethod.Value == "text"
                && this.selectedRecipient
                && (!this.selectedRecipient.MobileNumber)) {

                // validate phone number
                const valid = this.accountService.validatePhoneNumber(searchTerm);
                if (!valid.success) {
                    this.showNotification(valid.error, undefined, undefined, "error");
                    return;
                }

                this.selectedRecipient.MobileNumber = this.accountService.parsePhoneNumber(searchTerm);
            }

            if (this.selectedTransferMethod
                && this.selectedTransferMethod.Value == "email"
                && this.selectedRecipient
                && (!this.selectedRecipient.Email)) {
                this.selectedRecipient.Email = searchTerm;
            }
        }

        this.tickets.forEach((ticket) => {
            ticket.OwnerID = this.notificationsService.loggedInUser.OwnerID;
        });

        this.ticketsService.transferTickets(this.selectedRecipient, this.tickets, this.cid, this.receiptFlag, this.selectedTransferMethod.Value, this.dbName)
            .subscribe((value) => {
                if (value && value.ResultFlag && !value.ResultMessage) {
                    this.showNotification("Transfer successful.", undefined, undefined, "success");
                } else if (value && !value.ResultFlag && value.ResultMessage && value.ResultMessage.length > 0) {
                    this.showNotification(value.ResultMessage, undefined, undefined, "error");
                }
                this.Cancel();
            });
    }

    filterRecipients(ev: any, recipients: TransferRecipient[]): TransferRecipient[] {
        this.filteredRecipients = null;
        const searchByText = this.selectedTransferMethod && this.selectedTransferMethod.Value == "text" && this.selectedTransferMethod.IsSelected;
        if (!this.recipientIsSet) {
            this.loggingService.debug("Search term", ev.value);
            if (ev && ev.value && ev.value.toString().trim().length > 0) {
                this.searchTerm = ev.value;
                if (searchByText) {
                    this.filteredRecipients = recipients.filter(r => r.MobileNumber
                        && r.MobileNumber
                        && (r.MobileNumber.toString().indexOf(ev.value) > -1
                            || r.FirstName.toLowerCase().indexOf(ev.value) > -1
                            || r.LastName.toLowerCase().indexOf(ev.value) > -1));
                } else {
                    this.filteredRecipients = recipients.filter(r => r.Email
                        && r.Email.length > 0
                        && (r.Email.indexOf(ev.value) > -1
                            || r.FirstName.toLowerCase().indexOf(ev.value) > -1
                            || r.LastName.toLowerCase().indexOf(ev.value) > -1));
                }

            } else {
                this.searchTerm = null;
            }

            this.loggingService.debug("Filtered recipients", this.filteredRecipients);
            return this.filteredRecipients;
        } else {
            if (searchByText) {
                if (this.searchTerm != this.selectedRecipient.MobileNumber) {
                    this.recipientIsSet = false;
                    this.selectedRecipient = new TransferRecipient();
                    this.filterRecipients(ev, recipients);

                }
            } else {
                if (!searchByText && (this.searchTerm != this.selectedRecipient.Email)) {
                    this.recipientIsSet = false;
                    this.selectedRecipient = new TransferRecipient();
                    this.filterRecipients(ev, recipients);

                }
            }

        }

    }

    clearSearchResults(): void {
        this.filteredRecipients = null;
    }

    recipientFieldsAreValid(): boolean {
        let valid = false;

        if (this.selectedRecipient) {
            if (this.selectedTransferMethod.Value == "text") {

                this.selectedRecipient.MobileNumber = this.searchTerm;

                if (this.selectedRecipient.FirstName && this.selectedRecipient.FirstName.length > 0
                    && this.selectedRecipient.LastName && this.selectedRecipient.LastName.length > 0
                    && this.selectedRecipient.MobileNumber && this.selectedRecipient.MobileNumber.toString().length > 0) {
                    valid = true;
                }
            } else if (this.selectedTransferMethod.Value == "email") {

                this.selectedRecipient.Email = this.searchTerm;

                if (this.selectedRecipient.FirstName && this.selectedRecipient.FirstName.length > 0
                    && this.selectedRecipient.LastName && this.selectedRecipient.LastName.length > 0
                    && this.selectedRecipient.Email && this.selectedRecipient.Email.length > 0) {
                    valid = true;
                }
            } else {
                this.showNotification("Please select a transfer method.", undefined, undefined, "warning");
            }


        }
        this.recipientIsSet = valid;
        this.loggingService.debug("Recipient Validation FLAG", valid);
        return valid;
    }

    selectRecentRecipient(selectedRecipient: TransferRecipient) {
        this.recipientIsSet = true;
        this.searchTerm = (selectedRecipient.MobileNumber || selectedRecipient.Email);
        this.selectedRecipient = selectedRecipient;
        this.filteredRecipients = null;
    }



}



// WEBPACK FOOTER //
// ./src/components/transfer-tickets/transfer-tickets.ts